import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';

import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as commonActions from '../../../store/actions/common.actions';
import * as fromRootStore from '../../../reducers';

import { ReferenceService } from '../../../services/index';
import { ReferenceModel } from '../../../model/index';

@Component({
    selector: 'add-edit-reference-window',
    templateUrl: './addEditReference.component.html'
})
export class AddEditReferenceComponent implements OnInit {
    title: string;
    public mode: string;
    public list: any[] = [];
    @Input() from_page;
    //public referencedata: any[] = [];
    @Input() referencedata: ReferenceModel[] = [];
    @Output() referenceLoadEvent = new EventEmitter();
    // trigger-variable for Ladda
    isLoading: boolean = false;
    typeCtrl: FormControl;
    statusCtrl: FormControl;
    sourceCtrl: FormControl;
    typeList = [];
    smsList = [];
    statusList = ['Active','Inactive'];

    constructor(private referenceService: ReferenceService, public snackBar: MdSnackBar,
     public bsModalRef: BsModalRef, public toasterService: ToasterService) 
    {
         //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidType(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Newspaper" && ledgerID != "Others") {
                retVal = { inValidReference: true };
            }

            return retVal;
        }
        this.typeCtrl = new FormControl('', [
            Validators.required,
            hasValidType.bind(this)
        ]);
        this.statusCtrl = new FormControl('', [
            Validators.required
        ]);
     
     // this.typeList = ['Doctor', 'Newspaper', 'Others'];

     // this.typeCtrl = new FormControl();
    }

    ngOnInit(): void {

        this.typeList = ['Newspaper', 'Others'];

        this.smsList = ['YES', 'NO'];

        setTimeout(() => {
            $('#reference_type').focus();
        }, 1000);
    }

    onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }

    onSaveReference(): void {
        let that = this;
        // data = {
        // 	mode: this.referencedata['mode']
        // };
        this.isLoading = true;
        this.referenceService
            .addEditUpdateReference(this.referencedata)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.bsModalRef.hide();
                    that.referenceLoadEvent.emit();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };

                    that.toasterService.pop(toast);
                }

            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/reference/addEditReference.component.ts